<template>
  <div>
    <b-modal ref="PartnerContactModal" :title="modalTitle" :no-close-on-backdrop="true">
      <div>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.name_short')}}</label>
            <input class="form-control" v-model="partnerContactData.name" placeholder="Enter name"
                   :class="{ required: !partnerContactData.name}"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.country')}}</label>
            <multiselect v-model="partnerContactData.country" :max-height="200"
                         placeholder="Choose country" label="name" track-by="name"
                         :options="countries"
                         :class="{ required: !partnerContactData.country}"
                         :close-on-select="true"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.county')}}</label>
            <input class="form-control" v-model="partnerContactData.state" placeholder="Enter county">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.city')}}</label>
            <input class="form-control" v-model="partnerContactData.city" placeholder="Enter city"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.street')}}</label>
            <input class="form-control" v-model="partnerContactData.street" placeholder="Enter street"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.postal_code')}}</label>
            <input class="form-control" v-model="partnerContactData.postcode"
                   placeholder="Enter postal code"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.vat')}}</label>
            <input class="form-control" v-model="partnerContactData.vat_code"
                   placeholder="Enter vat code"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.partner.phone')}}</label>
            <vue-tel-input class="form-control phone-number" placeholder="+ XX XX XXXXXXX"
                           v-model="partnerContactData.phone">
            </vue-tel-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Email</label>
            <input class="form-control" v-model="partnerContactData.email"
                   placeholder="Enter email"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.notes')}}</label>
            <input class="form-control" v-model="partnerContactData.notes" placeholder="Enter notes"/>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer" class="w-100 text-center">
        <b-btn size="sm" variant="success" @click="savePartnerContact">
          {{$t('buttons.common.save')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import { VueTelInput } from 'vue-tel-input';
  import { mapGetters } from 'vuex';
  import { notificationsRenderer } from '@/helpers/renderHelpers';

  import {
    handlerResponse
  } from '../../helpers/commonHelpers';

  export default {
    props: ['id', 'fetchDeliveryAddresses'],
    components: {
      Multiselect,
      VueTelInput
    },
    data() {
      return {
        isNewPartnerContact: true,
        partnerContactData: {},
        partnerContactDataInitial: {
          name: '',
          city: '',
          state: '',
          street: '',
          country: null,
          postcode: '',
          vat_code: '',
          email: '',
          phone: '',
          notes: ''
        }
      }
    },
    methods: {
      savePartnerContact() {
        const savedData = {
          ...this.partnerContactData, ...{
            country: this.partnerContactData.country && this.partnerContactData.country.short_name
          }
        };
        if (this.isNewPartnerContact) {
          this.$http.post(`partner/partners/${this.id}/delivery_addresses/`, savedData).then(handlerResponse).then(() => {
            if (this.fetchDeliveryAddresses) {
              this.fetchDeliveryAddresses();
            } else {
              this.$store.dispatch('generalPartner/loadPartnerContacts', {id: this.id});
            }
            this.$refs['PartnerContactModal'].hide();
          }).catch(error => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        } else {
          const partnerContactId = this.partnerContactData.id;
          this.$http.put(`partner/partners/${this.id}/delivery_addresses/${partnerContactId}/`, savedData).then(handlerResponse).then(() => {
            this.$store.dispatch('generalPartner/loadPartnerContacts', {id: this.id});
            this.$refs['PartnerContactModal'].hide();
          }).catch(error => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      }
    },
    computed: {
      ...mapGetters('woodware', {
        countries: 'countries'
      }),
      modalTitle() {
        return `${this.$i18n.t('modal_dialogs.partner.partner_contact')}`;
      }
    },
    mounted() {
      this.$root.$on('openPartnerContactModal', (data) => {
        this.isNewPartnerContact = data.isNew;
        delete data.isNew;
        this.partnerContactData = {...this.partnerContactDataInitial};
        (async () => {
          await this.$store.cache.dispatch('woodware/getCountries');
          if (this.$refs['PartnerContactModal']) {
            this.$refs['PartnerContactModal'].show();
            if (!this.isNewPartnerContact) {
              this.partnerContactData = {...data};
            } else if (data.roles) {
              this.partnerContactData.roles = data.roles;
            }
          }
        })();
      })
    },
    beforeDestroy() {
      this.$root.$off('openPartnerContactModal');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PartnerContactModal.vue